import { CAMPAIGN_STATUSES } from "../constants";

/**
 * Check if delete action is enabled for a given item based on campaign status
 * @param {Object} item - The item (media/targetGroup) to check
 * @param {string} campaignStatus - The status of the parent campaign
 * @returns {boolean} - Whether delete is enabled
 */
export const isDeleteEnabled = (item, campaignStatus) => {
  // Only enable delete in these scenarios
  return (
    campaignStatus === CAMPAIGN_STATUSES.DRAFT ||
    campaignStatus === CAMPAIGN_STATUSES.PLANNED ||
    ((campaignStatus === CAMPAIGN_STATUSES.ACTIVE || campaignStatus === CAMPAIGN_STATUSES.PAUSED) &&
      item.status === CAMPAIGN_STATUSES.DRAFT)
  );
};
